<template>
    <div class="container">
        <notifications />
        <div class="col-lg-6 col-md-6 ml-auto mr-auto">
            <form @submit.prevent="login">
                <card class="card-login card-white">
                    <template slot="header">
                        <img class="login-logo" src="img/logo.png" />
                    </template>
                    <div>
                        <base-input
                            id="username"
                            v-model.trim="credentials.username"
                            v-validate="'required'"
                            name="username"
                            :error="getError('username')"
                            placeholder="Username"
                            addon-left-icon="tim-icons icon-single-02"
                            autocomplete="username"
                        />
                        <base-input
                            id="password"
                            v-model="credentials.password"
                            v-validate="'required'"
                            name="password"
                            :error="getError('password')"
                            type="password"
                            placeholder="Password"
                            addon-left-icon="tim-icons icon-lock-circle"
                            autocomplete="current-password"
                        />
                    </div>
                    <div slot="footer">
                        <base-button
                            id="login"
                            native-type="submit"
                            type="primary"
                            class="mb-3"
                            size="lg"
                            block
                        >
                            Log In
                        </base-button>
                    </div>
                </card>
                <p>
                    If you don't know your login information, please call us at
                    (303) 922-2429 or send an email to ken@deliverybydesign.com
                </p>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    props: {
        redirect: {
            type: String,
            default: "/",
        },
    },
    data() {
        return {
            credentials: {
                username: null,
                password: null,
            },
        };
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        login() {
            this.$emit("login", this.credentials, this.redirect);
        },
    },
};
</script>
<style>
.navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
}
.login-logo {
    position: relative !important;
    margin: 0 auto;
    display: block;
}
</style>
